import { PERMISSIONS } from '@access/permissions';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { IDeviceNotificationModel } from '@notifications/abstract/device-notification-model';
import { INotificationAvailableDevice } from '@notifications/abstract/notification-available-device';
import { fadeInOut } from '@notifications/constants/animations';
import { DeviceNotificationType } from '@notifications/constants/device-notification-type';
import { DeviceNotificationService } from '@notifications/services/device-notification.service';
import { Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss'],
  animations: [fadeInOut],
})
export class NotificationMenuComponent implements OnInit, OnDestroy {
  @ViewChild('menu') notificationMenu!: ElementRef<any>;
  private subscriptions = new Subscription();

  webNotifications: IDeviceNotificationModel[] = [];

  readonly DeviceNotificationType = DeviceNotificationType;

  availableDevices: INotificationAvailableDevice[] = [];
  selectedDeviceId: string = '-1';
  currentPage = 0;

  readonly permissions = PERMISSIONS;

  constructor(
    private readonly deviceNotificationService: DeviceNotificationService
  ) {
    this.subscriptions.add(
      this.deviceNotificationService.deviceNotifications$.subscribe(
        (res: IDeviceNotificationModel[]) => {
          this.webNotifications = res;
        }
      )
    );
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  onClose() {
    this.currentPage = 0;
    if (this.notificationMenu.nativeElement.classList.contains('active')) {
      this.toggleNotificationsMenu();
    }
  }

  trackByFn(index: number, item: any) {
    return item.id;
  }

  onDeviceFilterChange(event: any) {
    this.currentPage = 0;
    this.deviceNotificationService.clearArrayOfUserDeviceNotifications();
    this.onScroll();
  }

  toggleNotificationsMenu() {
    this.notificationMenu.nativeElement.classList.toggle('active');

    if (this.notificationMenu.nativeElement.classList.contains('active')) {
      this.subscriptions.add(
        this.deviceNotificationService
          .getAvailableDevices()
          .subscribe((res) => {
            this.availableDevices = res;
          })
      );

      if (this.webNotifications.length > 0) {
        this.subscriptions.add(
          this.deviceNotificationService
            .markAsRead(this.webNotifications.filter((x) => !x.isRead))
            .subscribe()
        );
      }
    }
  }

  clearNotification(webNotification: IDeviceNotificationModel): void {
    this.subscriptions.add(
      this.deviceNotificationService
        .clearNotification(webNotification)
        .subscribe()
    );
  }

  clearAllNotifications(): void {
    this.subscriptions.add(
      this.deviceNotificationService.clearAll(this.webNotifications).subscribe()
    );
  }

  onScroll(): void {
    this.subscriptions.add(
      this.deviceNotificationService
        .getPage(
          10,
          this.currentPage,
          this.selectedDeviceId == "-1" ? null : this.selectedDeviceId
        )
        .pipe(
          tap((res) => {
            this.currentPage = res.currentPage + 1;
          })
        )
        .subscribe()
    );
  }
}
